import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import LocationOnIcon from '@mui/icons-material/LocationOn'

export const RecorteLocalizacaoFilterPreview = () => {
    // State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeEditRecorteFormFiltros } = useRecortesExtracaoService()

    const hasLocalizacao = editRecorteExtracaoForm.fields.Filtros?.localizacao &&
        editRecorteExtracaoForm.fields.Filtros.localizacao.length > 0;

    const handleRemoveFilter = () => {
        removeEditRecorteFormFiltros({ filtro: 'localizacao' });
    };

    if (!hasLocalizacao) {
        return null;
    }

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Localização
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={handleRemoveFilter}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {editRecorteExtracaoForm.fields.Filtros &&
                        editRecorteExtracaoForm.fields.Filtros.localizacao && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {editRecorteExtracaoForm.fields.Filtros.localizacao.map((localizacao, i) => (
                                        <Chip
                                            key={i}
                                            icon={<LocationOnIcon />}
                                            label={
                                                localizacao.value ?
                                                    localizacao.categoria && localizacao.categoria === 'bairro' ? `${localizacao.bairro} - ${localizacao.cidade} / ${localizacao.uf}`
                                                        : localizacao.value.toUpperCase()
                                                    : ''
                                            }
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}